<!-- 
Panel for displaying configured email addresses.
-->
<template>
  <div class="my-0">
    <our-data-container>
      <our-data-field label="LTPS operations email address" label-width="3">{{ configuration.ltpsOperationsEmail }}</our-data-field>
      <our-data-field label="LTPS accounts email address" label-width="3">{{ configuration.levyAccountsEmail }}</our-data-field>
    </our-data-container>
    <div class="text-xs-center py-2">
      <v-btn v-if="canEdit" @click="showEditDialog=true">
        <v-icon class="mr-2">edit</v-icon>
        Edit
      </v-btn>
    </div>
    <email-configuration-dialog v-model="showEditDialog" :levy-collection-id="levyCollectionId" />
  </div>
</template>

<script>
import lookupMixins from "@/mixins/lookup.mixins";
import filterMixins from "@/mixins/filter.mixins";
import * as claim from "@/store/claim-types";
import * as action from "@/store/levy-collections/action-types";
import EmailConfigurationDialog from "@/components/levy-collection-setup/EmailConfigurationDialog.vue";

export default {
  components: { EmailConfigurationDialog },
  mixins: [lookupMixins, filterMixins],
  props: {
    levyCollectionId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      showEditDialog: false
    };
  },
  computed: {
    state() {
      return this.$store.state.levyCollections.viewEmailConfiguration;
    },
    loaded() {
      return this.state.loaded;
    },
    configuration() {
      return this.state.data;
    },
    canEdit() {
      const hasPermission = this.$store.getters.claims.includes(claim.LEVY_COLLECTION_CONFIGURE_EMAIL);
      const isAllowableStatus = this.doesLookupHaveAttribute(
        this.configuration.status,
        "CanEditEmailConfiguration",
        this.lookups.levyCollectionStatuses
      );
      return hasPermission && isAllowableStatus;
    }
  },
  watch: {
    levyCollectionId() {
      this.refresh();
    },
    loaded() {
      this.refresh();
    }
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      const needsReloaded =
        (!this.state.loaded && !this.state.loading) || this.state.levyCollectionId != this.levyCollectionId;
      if (needsReloaded) {
        this.$store.dispatch(action.VIEW_EMAIL_CONFIGURATION, this.levyCollectionId);
      }
    }
  }
};
</script>
